(function() {
  var DialogController,
    bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  DialogController = App.loadClass('core::Angular/DialogController');

  exports.FieldDetailsController = (function(superClass) {
    extend(FieldDetailsController, superClass);

    function FieldDetailsController(scope, http, transitions, transition$, $modalInstance, q, rootScope, state) {
      var ref, year;
      this.scope = scope;
      this.http = http;
      this.transitions = transitions;
      this.transition$ = transition$;
      this.q = q;
      this.rootScope = rootScope;
      this.state = state;
      this.formatFieldForSave = bind(this.formatFieldForSave, this);
      this.formatDetailsForSave = bind(this.formatDetailsForSave, this);
      this.save = bind(this.save, this);
      FieldDetailsController.__super__.constructor.call(this, this.scope, this.transitions, $modalInstance);
      this.scope.drainage_options = ['Well', 'Moderate', 'Poor'];
      this.scope.editing = this.transition$.params().editing === "true";
      year = (ref = this.transition$.params().year) != null ? ref : (new Date()).getFullYear();
      this.scope.title = "Field Details " + year;
      this.http.post('backend/grower/layers/management-zones/get-irrigation-methods').then((function(_this) {
        return function(response) {
          var ref1;
          _this.scope.irrigation_options = response.data.data;
          _this.scope.loadingFieldDetails = true;
          return _this.http.post('backend/grower/fields/get-field-details', {
            field_id: _this.transition$.params().id,
            year: (ref1 = _this.transition$.params().year) != null ? ref1 : null
          }).then(function(response) {
            var i, len, option, ref1, results;
            _this.scope.loadingFieldDetails = false;
            if (response.data.data) {
              _this.scope.field = response.data.data.field;
              _this.scope.details = response.data.data.details;
              _this.scope.field.tillable_acres = Math.round(_this.scope.field.tillable_acres * 10) / 10;
              ref1 = _this.scope.irrigation_options;
              results = [];
              for (i = 0, len = ref1.length; i < len; i++) {
                option = ref1[i];
                if (option.name === _this.scope.details.irrigation_method) {
                  results.push(_this.scope.details.irrigation_method = option);
                }
              }
              return results;
            }
          });
        };
      })(this));
      this.http.post('backend/grower/farms/list').then((function(_this) {
        return function(response) {
          return _this.scope.farms = response.data.data;
        };
      })(this));
    }

    FieldDetailsController.prototype.save = function(pretending) {
      if (pretending == null) {
        pretending = true;
      }
      return this.http.post('backend/grower/fields/save-field-details', {
        details: this.formatDetailsForSave(),
        field: this.formatFieldForSave()
      }).then((function(_this) {
        return function(response) {
          if (!pretending) {
            _this.closeWithAlert({
              type: 'success',
              msg: 'Field details saved'
            }, null, 2000);
          }
          return response;
        };
      })(this))["catch"]((function(_this) {
        return function(response) {
          if (response.status === 422) {
            return _this.q.reject(response);
          }
        };
      })(this));
    };

    FieldDetailsController.prototype.formatDetailsForSave = function() {
      var ref, ref1, ref2;
      return {
        id: this.scope.details.id,
        irrigation_method: (ref = (ref1 = this.scope.details.irrigation_method) != null ? ref1.name : void 0) != null ? ref : null,
        drainage: (ref2 = this.scope.details.drainage) != null ? ref2 : null,
        field_id: this.scope.details.fields_id,
        year: this.scope.details.year
      };
    };

    FieldDetailsController.prototype.formatFieldForSave = function() {
      return {
        id: this.scope.field.id,
        farms_id: this.scope.field.farm.id,
        name: this.scope.field.name,
        user_id: this.scope.field.owner.id
      };
    };

    return FieldDetailsController;

  })(DialogController);

}).call(this);
